import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { useBoards } from "../reactQuery/boards";
import { getResponseData } from "../reactQuery/response";
import { resolveBoardFromRouteId } from "./hookUtils";

/**
 * Hook to get the board ID from the board key in the URL params
 * Supports both new URL format (with board key) and old format (with numeric ID)
 * 
 * @returns {Object} Object containing id (board_id) and board object
 */
const useBoardIdByKey = () => {
  const { id } = useParams();
  const { isLoading, boards, isError } = useBoards();
  const responseData = getResponseData(boards, []);
  const boardState = useMemo(
    () => resolveBoardFromRouteId(id, responseData),
    [id, responseData]
  );
  
  if (isLoading || isError || !responseData.length) {
    return { id: null, board: null, isLoading, isError };
  }

  return {
    ...boardState,
    isLoading,
    isError,
  };
};

export default useBoardIdByKey;
